'use client';

import ErrorPageRecommendations from '@/app/components/ErrorPageRecommendations';
import ErrorPageView from '@/components/ErrorPage/ErrorPageView';
import { setSession } from '@/utils/tools';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function NotFound() {
  const router = useRouter();
  const [recommendationsVisible, setRecommendationsVisible] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <ErrorPageView
      type="404"
      recommendationsVisible={recommendationsVisible}
      recommendations={
        <ErrorPageRecommendations
          onVisibilityChange={setRecommendationsVisible}
          onItemClick={() => {
            setSession('zl_goodsDetailEnterPageScene', '404页面猜你喜欢坑位');
          }}
        />
      }
      onBackHome={() => router.push('/')}
    />
  );
}
